// dna_frontend/src/pages/AdminUploadThuMau.js
// (*** ĐÃ TINH CHỈNH GIAO DIỆN HIỂN THỊ KẾT QUẢ ***)

import React, { useState } from 'react';
import api from '../services/api';

function AdminUploadThuMau() {
  const [file, setFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  
  const [fuzzyReport, setFuzzyReport] = useState(null); 
  const [notFoundReport, setNotFoundReport] = useState(null); 
  const [pendingFile, setPendingFile] = useState(null); 

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
    setPendingFile(selectedFile); 
    setError(null);
    setSuccess(null);
    setFuzzyReport(null);
    setNotFoundReport(null);
  };
  
  const resetState = () => {
    setError(null);
    setSuccess(null);
    setFuzzyReport(null);
    setNotFoundReport(null);
    setPendingFile(null);
    setIsLoading(false);
    const fileInput = document.getElementById('file-upload-input');
    if (fileInput) fileInput.value = null;
    setFile(null);
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) {
      setError({ message: 'Vui lòng chọn một file Excel.' });
      return;
    }

    setIsLoading(true);
    setError(null);
    setSuccess(null);
    setFuzzyReport(null);
    setNotFoundReport(null);
    
    const formData = new FormData();
    formData.append('file', file);

    try {
      const res = await api.post('/data/upload-da-thu-mau', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setSuccess(res.data);
      // (Sửa) Không gọi resetState ngay để người dùng kịp đọc kết quả
      setFile(null);
      const fileInput = document.getElementById('file-upload-input');
      if (fileInput) fileInput.value = null;
    } catch (err) {
      const resError = err.response?.data;
      if (resError && resError.status === 'requires_confirmation') {
        setFuzzyReport(resError.fuzzyMatchesInDB);
        setNotFoundReport(resError.notFoundInDB); 
        setPendingFile(file); 
        setError(null); 
      } else {
        setError(resError || { message: 'Lỗi không xác định' });
        setPendingFile(null); 
      }
    } finally {
      setIsLoading(false);
    }
  };
  
  const handleForceSubmit = async () => {
     if (!pendingFile) {
         setError({ message: 'Lỗi: Không tìm thấy file chờ xử lý.' });
         return;
     }
     setIsLoading(true);
     setError(null);
     setSuccess(null);

     const formData = new FormData();
     formData.append('file', pendingFile);
     formData.append('force_insert', 'true'); 

     try {
        const res = await api.post('/data/upload-da-thu-mau', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        setSuccess(res.data);
     } catch (err) {
        setError(err.response?.data || { message: 'Lỗi không xác định khi commit' });
     } finally {
        setIsLoading(false);
        setPendingFile(null);
        setFuzzyReport(null);
        setNotFoundReport(null);
        const fileInput = document.getElementById('file-upload-input');
        if (fileInput) fileInput.value = null;
        setFile(null);
     }
  }

  
  const renderErrorDetails = () => {
    if (!error) return null;
    return (
      <div style={{ background: '#fff0f0', border: '1px solid red', padding: '10px', marginTop: '15px' }}>
        <h4 style={{ color: 'red', marginTop: 0 }}>{error.message}</h4>
        
        {error.duplicatesInFile && error.duplicatesInFile.length > 0 && (
          <div>
            <strong style={{color: '#b71c1c'}}>Lỗi 1: Trùng lặp trong File (File của bạn có 2 key giống nhau):</strong>
            <ul>{error.duplicatesInFile.map((err, i) => (<li key={i}>Dòng {err.line}: Key <code>{err.key_text}</code> (Trùng với dòng {err.original_line})</li>))}</ul>
          </div>
        )}
        
        {error.duplicatesInDB && error.duplicatesInDB.length > 0 && (
          <div>
            <strong style={{color: '#b71c1c'}}>Lỗi 2: Trùng lặp chính xác trong CSDL (Bạn cần xử lý riêng):</strong>
            <ul>{error.duplicatesInDB.map((err, i) => (<li key={i}>Dòng {err.line}: Key <code>{err.key_text}</code> {err.message} (IDs: {err.db_ids.join(', ')})</li>))}</ul>
          </div>
        )}

        {error.fuzzyMatchesInDB && error.fuzzyMatchesInDB.length > 0 && (
          <div>
            <strong style={{color: '#b71c1c'}}>Lỗi 3: Trùng lặp Tương đối (Lệch Năm sinh):</strong>
            <ul>{error.fuzzyMatchesInDB.map((err, i) => (<li key={i}>Dòng {err.line}: Key <code>{err.key_file}</code> - {err.message}</li>))}</ul>
          </div>
        )}
        
        {error.notFoundInDB && error.notFoundInDB.length > 0 && (
          <div>
            <strong style={{color: '#b71c1c'}}>Lỗi 4: Không tìm thấy:</strong>
            <ul>{error.notFoundInDB.map((err, i) => (<li key={i}>Dòng {err.line}: Key <code>({err.ho_ten}, {err.nam_sinh}, {err.cccd})</code> - {err.message}</li>))}</ul>
          </div>
        )}

        {error.errorsInFile && error.errorsInFile.length > 0 && (
          <div>
            <strong style={{color: '#b71c1c'}}>Lỗi 5: Dữ liệu trong File (Thiếu cột hoặc sai Tên Xã/Năm sinh/Ngày thu):</strong>
            <ul>{error.errorsInFile.map((err, i) => (<li key={i}>Dòng {err.line}: {err.message}</li>))}</ul>
          </div>
        )}
      </div>
    );
  };
  
  const renderConfirmation = () => {
    const hasFuzzy = fuzzyReport && fuzzyReport.length > 0;
    const hasNotFound = notFoundReport && notFoundReport.length > 0;
    
    if (!hasFuzzy && !hasNotFound) return null;
    
    return (
        <div style={{ background: '#fff8e1', border: '1px solid #ffc107', padding: '10px', marginTop: '15px' }}>
            <h4 style={{ color: '#f57f17', marginTop: 0 }}>Cảnh báo: Phát hiện dữ liệu cần xác nhận</h4>
            
            {hasFuzzy && (
                <>
                <p><strong>Cảnh báo 1: Dữ liệu NGHI NGỜ trùng lặp (lệch 1 năm sinh):</strong></p>
                <ul style={{maxHeight: '200px', overflowY: 'auto', background: 'white', padding: '10px'}}>
                  {fuzzyReport.map((err, i) => (
                    <li key={i}>
                      Dòng {err.line}: <code>{err.key_file}</code>
                      <br/>
                      <span style={{color: 'red'}}>Nghi ngờ: {err.message}</span>
                      {err.matches && err.matches.map((m, j) => (
                         <span key={j} style={{display: 'block', marginLeft: '15px'}}>
                            - CSDL có: (ID: {m.id}, Năm sinh: {m.nam_sinh}, Xã: {m.ten_xa})
                         </span>
                      ))}
                    </li>
                  ))}
                </ul>
                </>
            )}
            
            {hasNotFound && (
                 <>
                <p><strong>Cảnh báo 2: Dữ liệu KHÔNG TÌM THẤY (sẽ được thêm mới):</strong></p>
                <ul style={{maxHeight: '200px', overflowY: 'auto', background: 'white', padding: '10px'}}>
                  {notFoundReport.map((err, i) => (
                    <li key={i}>
                      Dòng {err.line}: <code>({err.ho_ten}, {err.nam_sinh}, {err.cccd})</code> - {err.message}
                    </li>
                  ))}
                </ul>
                </>
            )}
            
            <p style={{fontWeight: 'bold'}}>Bạn có muốn tiếp tục không?</p>
            <p>
                - <strong>[Hủy bỏ]</strong>: (An toàn) Dừng upload, tôi sẽ kiểm tra và sửa lại file Excel.<br/>
                - <strong>[Vẫn tiếp tục]</strong>: Chấp nhận. Các dòng (thuộc cả 2 cảnh báo trên) sẽ được <strong>THÊM MỚI</strong> vào CSDL.
            </p>
            <div style={{display: 'flex', gap: '10px', marginTop: '15px'}}>
                 <button type="button" onClick={resetState} disabled={isLoading} style={{background: '#6c757d', color: 'white', padding: '10px 15px'}}>
                    Hủy bỏ
                 </button>
                 <button type="button" onClick={handleForceSubmit} disabled={isLoading} style={{background: '#dc3545', color: 'white', padding: '10px 15px'}}>
                    {isLoading ? 'Đang xử lý...' : 'Vẫn tiếp tục (Thêm mới)'}
                 </button>
            </div>
        </div>
    );
  }

  return (
    <div style={{ padding: '20px' }}>
      <h2>Upload danh sách ĐÃ THU MẪU (Thêm mới hoặc Cập nhật)</h2>
      
      {!fuzzyReport && !notFoundReport && (
        <>
          <p>Hệ thống sẽ dùng file này để cập nhật trạng thái `da_thu_mau` cho thân nhân.</p>
          <p>File Excel phải có 4 cột bắt buộc: 
              <strong>ten_xa</strong>, 
              <strong>ho_ten</strong>, 
              <strong>nam_sinh</strong> (YYYY),
              <strong>cccd</strong>.
          </p>
          <p style={{background: '#e6f7ff', border: '1px solid #b3e0ff', padding: '10px'}}>
              <strong>CỘT MỚI (Tùy chọn):</strong> Thêm cột <strong>ngay_thu</strong>.
              <br/>
              - Nếu cung cấp, hệ thống sẽ lưu ngày này (định dạng YYYY-MM-DD hoặc MM/DD/YY).
              <br/>
              - Nếu bỏ trống, hệ thống sẽ tự động lấy ngày giờ hiện tại (NOW()).
          </p>
          <p>Cột nên có (để Thêm mới): <strong>dia_chi</strong>.</p>
          <p style={{fontWeight: 'bold'}}>
             Key định danh = <code>Họ Tên + Năm Sinh + 3 số CCCD</code> (Toàn hệ thống).
          </p>
          
          <form onSubmit={handleSubmit}>
            <input type="file" id="file-upload-input" onChange={handleFileChange} accept=".xlsx, .xls" />
            <button type="submit" disabled={isLoading || !file}>
              {isLoading ? 'Đang xử lý...' : 'Upload và Kiểm tra'}
            </button>
          </form>
        </>
      )}

      {/* (*** ĐÃ TINH CHỈNH GIAO DIỆN HIỂN THỊ ***) */}
      {success && (
        <div style={{ background: '#d4edda', border: '1px solid #c3e6cb', padding: '20px', marginTop: '20px', borderRadius: '5px', textAlign: 'center' }}>
          <h2 style={{ color: '#155724', marginTop: 0 }}>{success.message}</h2>
          
          <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '15px'}}>
              <div>
                  <h3 style={{margin: 0, color: '#007bff'}}>{success.totalKeysInFile}</h3>
                  <small>Tổng dòng hợp lệ</small>
              </div>
              <div>
                  <h3 style={{margin: 0, color: '#ffc107'}}>{success.updatedCount}</h3>
                  <small>Đã CẬP NHẬT (Update)</small>
              </div>
              <div>
                  <h3 style={{margin: 0, color: '#28a745'}}>{success.insertedCount}</h3>
                  <small>Đã THÊM MỚI (Insert)</small>
              </div>
          </div>
          
          <div style={{marginTop: '20px'}}>
              <button onClick={resetState} style={{padding: '10px 20px', background: '#28a745', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer'}}>
                  Tiếp tục upload file khác
              </button>
          </div>
        </div>
      )}
      
      {renderConfirmation()}
      
      {!fuzzyReport && !notFoundReport && renderErrorDetails()}
    </div>
  );
}

export default AdminUploadThuMau;